"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowRemoveElement = allowRemoveElement;
exports.checkForPawnData = checkForPawnData;
exports.checkForUniqueHandle = checkForUniqueHandle;
exports.checkIfNeedToSaveAgain = void 0;
exports.exportFlow = exportFlow;
exports.getCurrentGmtTime = exports.getCurrentFormattedGmtTime = void 0;
exports.getFlowTypes = getFlowTypes;
exports.getObjectHash = getObjectHash;
exports.removeDataConnectors = removeDataConnectors;
exports.replaceIds = void 0;
exports.required = required;
var _objectHash = _interopRequireDefault(require("object-hash"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _flat = _interopRequireDefault(require("flat"));
var _dateFnsTimezone = require("date-fns-timezone");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Flow = window.cccisd && window.cccisd.flow;
if (!Flow || !Flow.config) {
  throw new Error('You have to include global_javascript from Flow package');
}
var getCurrentGmtTime = function getCurrentGmtTime() {
  var durationFromStart = Math.round(performance.now()) - Flow.clientStartTimeMs;
  return Flow.serverStartTimeMs + durationFromStart;
};
exports.getCurrentGmtTime = getCurrentGmtTime;
var getCurrentFormattedGmtTime = function getCurrentFormattedGmtTime() {
  return (0, _dateFnsTimezone.formatToTimeZone)(getCurrentGmtTime(), 'YYYY-MM-DD HH:mm:ss', {
    timeZone: 'Europe/London'
  });
};
exports.getCurrentFormattedGmtTime = getCurrentFormattedGmtTime;
var checkIfNeedToSaveAgain = function checkIfNeedToSaveAgain(elements, data) {
  var tmpIds = (0, _filter2["default"])(data, function (o) {
    return o.tmpId;
  }).map(function (o) {
    return o.tmpId;
  });
  var connectorsIds = [];
  function getConnectorIds(item, key, collection) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isObject2["default"])(item) && item.instance === 'dataConnector' && item.category === 'flow' && !connectorsIds.includes(item.id)) {
      connectorsIds.push(item.id);
    } else {
      (0, _forEach2["default"])(item, getConnectorIds);
    }
  }
  getConnectorIds(elements);
  return (0, _intersection2["default"])(tmpIds, connectorsIds).length > 0;
};
exports.checkIfNeedToSaveAgain = checkIfNeedToSaveAgain;
var replaceIds = function replaceIds(elements, topId, newId) {
  var newIds = {};
  (0, _map2["default"])(elements, function (o) {
    return o.id;
  }).forEach(function (id) {
    newIds[id] = newId++;
  });
  var newElements = {};
  (0, _forEach2["default"])(elements, function (value, key) {
    newElements[newIds[key]] = _objectSpread(_objectSpread({}, value), {}, {
      id: newIds[value.id]
    }, value.children && {
      children: value.children.map(function (id) {
        return newIds[id];
      })
    });
  });

  // Change data connectors ids
  function replaceConnectorIds(item, key, collection) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isObject2["default"])(item) && item.instance === 'dataConnector' && item.category === 'flow') {
      collection[key] = _objectSpread(_objectSpread({}, item), {}, {
        id: newIds[item.id] || item.id
      });
      return;
    }
    (0, _forEach2["default"])(item, replaceConnectorIds);
  }
  replaceConnectorIds(newElements);
  return {
    elements: (0, _cloneDeep2["default"])(newElements),
    topId: newIds[topId],
    newId: newId
  };
};
exports.replaceIds = replaceIds;
function getObjectHash() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var removeUndefined = function removeUndefined(item) {
    if ((0, _isObject2["default"])(item)) {
      var result = {};
      (0, _forEach2["default"])(item, function (value, key) {
        if ((0, _isObject2["default"])(value) || (0, _isArray2["default"])(value)) {
          result[key] = removeUndefined(value);
        } else if (value !== undefined) {
          result[key] = value;
        }
      });
      return result;
    }
    if ((0, _isArray2["default"])(item)) {
      var _result = [];
      (0, _forEach2["default"])(item, function (value) {
        if ((0, _isObject2["default"])(value) || (0, _isArray2["default"])(value)) {
          _result.push(removeUndefined(value));
        } else if (value !== undefined) {
          _result.push(value);
        }
      });
      return _result;
    }
    return item;
  };
  return (0, _objectHash["default"])(removeUndefined(object));
}
function exportFlow(_ref) {
  var elements = _ref.elements,
    topId = _ref.topId,
    _ref$theSameFlow = _ref.theSameFlow,
    theSameFlow = _ref$theSameFlow === void 0 ? false : _ref$theSameFlow,
    _ref$isStripResources = _ref.isStripResources,
    isStripResources = _ref$isStripResources === void 0 ? true : _ref$isStripResources;
  if (!elements[topId]) {
    throw new Error("There is no element with id=".concat(topId));
  }

  // Get elements
  var pickedElements = {};
  function getElement(elementId) {
    var element = elements[elementId];
    if (!element) {
      return;
    }
    pickedElements[elementId] = (0, _cloneDeep2["default"])((0, _pick2["default"])(element, ['id', 'type', 'settings', 'children', 'skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage', 'isAdult']));

    // Remove adjustedPlayerSettings
    if (pickedElements[elementId].settings) {
      pickedElements[elementId].settings = (0, _omit2["default"])(pickedElements[elementId].settings, ['isAdjustedPlayerSettings', 'adjustedPlayerSettings']);
    }
    if (element.children) {
      element.children.forEach(function (child) {
        return getElement(child);
      });
    }
  }
  getElement(topId);
  var isStripedVisibilityConditions = false;
  var isStripedVariables = false;
  var isBrokenConnectors = false;
  var isRemovedAudios = false;
  var isRemovedImages = false;
  if (!theSameFlow) {
    // Get ids
    var ids = (0, _map2["default"])(pickedElements, function (o) {
      return o.id;
    });
    var stripResources = function stripResources(string) {
      return string.replace(/<img[^>]*>/gi, '');
    };

    // Mark broken connectors
    var markBrokenConnectors = function markBrokenConnectors(item, key, collection) {
      if ((0, _isString2["default"])(item) && isStripResources) {
        var adjustedString = stripResources(item);
        if (adjustedString !== item) {
          collection[key] = adjustedString;
          isRemovedImages = true;
        }
        return;
      }
      if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
        return;
      }

      // Remove broken variables from wysiwyg
      if ((0, _isObject2["default"])(item) && item.content && item.meta && item.meta.variables) {
        var brokenVars = [];
        (0, _forEach2["default"])(item.meta.variables, function (variable, name) {
          if (variable.category !== 'flow' || !ids.includes(variable.id)) {
            brokenVars.push(name);
          }
        });
        if (brokenVars.length > 0) {
          isStripedVariables = true;
          var regex = new RegExp("<span[^>]*data-variable=\"(".concat(brokenVars.join('|'), ")\"[^>]*>[^>]*</span>"), 'ig');
          item = _objectSpread(_objectSpread({}, item), {}, {
            content: item.content.replace(regex, ''),
            meta: _objectSpread(_objectSpread({}, item.meta), {}, {
              variables: (0, _omit2["default"])(item.meta.variables, brokenVars)
            })
          });
          collection[key] = item;
        }
      }

      // Remove audios from wysiwyg
      if (isStripResources && (0, _isObject2["default"])(item) && item.meta && item.meta.audio) {
        isRemovedAudios = true;
        item = _objectSpread(_objectSpread({}, item), {}, {
          meta: (0, _omit2["default"])(item.meta, ['audio'])
        });
        collection[key] = item;
      }

      // Remove broken connectors from visibility
      if ((0, _isObject2["default"])(item) && item.settings && (0, _isArray2["default"])(item.settings.showConditionsRules)) {
        var notBrokenConnectors = item.settings.showConditionsRules.filter(function (rule) {
          return rule.dataConnector.category === 'flow' && ids.includes(rule.dataConnector.id);
        });
        if (notBrokenConnectors.length < item.settings.showConditionsRules.length) {
          isStripedVisibilityConditions = true;
          item = _objectSpread(_objectSpread({}, item), {}, {
            settings: _objectSpread(_objectSpread({}, item.settings), {}, {
              showConditionsRules: notBrokenConnectors
            })
          });
          collection[key] = item;
        }
      }

      // Mark dataConnector as broken
      if ((0, _isObject2["default"])(item) && item.instance === 'dataConnector') {
        if (item.category !== 'flow' || !ids.includes(item.id)) {
          isBrokenConnectors = true;
          collection[key] = {
            instance: 'dataConnector',
            broken: true
          };
        }
        return;
      }
      (0, _forEach2["default"])(item, markBrokenConnectors);
    };
    markBrokenConnectors(pickedElements);
  }
  return {
    elements: pickedElements,
    topId: topId,
    meta: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isStripedVisibilityConditions && {
      isStripedVisibilityConditions: isStripedVisibilityConditions
    }), isStripedVariables && {
      isStripedVariables: isStripedVariables
    }), isBrokenConnectors && {
      isBrokenConnectors: isBrokenConnectors
    }), isRemovedAudios && {
      isRemovedAudios: isRemovedAudios
    }), isRemovedImages && {
      isRemovedImages: isRemovedImages
    })
  };
}
function getFlowTypes() {
  return _objectSpread(_objectSpread({}, Flow.config.app_flow_types), Flow.config.core_flow_types);
}
function removeDataConnectors(item) {
  if (!(0, _isPlainObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
    return item;
  }
  if ((0, _isPlainObject2["default"])(item) && item.instance === 'dataConnector') {
    return null;
  }
  if ((0, _isPlainObject2["default"])(item)) {
    return (0, _mapValues2["default"])(item, function (child) {
      return removeDataConnectors(child);
    });
  }
  return item.map(function (child) {
    return removeDataConnectors(child);
  });
}
function allowRemoveElement(elements, rootId, elementId) {
  var usedDataConnectorsIds = [];
  var getUsedDataConnectorsIds = function getUsedDataConnectorsIds(element) {
    var processItem = function processItem(item) {
      if (!(0, _isPlainObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
        return;
      }
      if ((0, _isPlainObject2["default"])(item) && item.instance === 'dataConnector' && item.category === 'flow') {
        usedDataConnectorsIds.push(item.id);
        return;
      }
      (0, _forEach2["default"])(item, function (child) {
        return processItem(child);
      });
    };
    processItem(element);
    if (element.children) {
      element.children.forEach(function (child) {
        return child !== elementId && getUsedDataConnectorsIds(elements[child]);
      });
    }
  };
  var getRemovedIds = function getRemovedIds(id) {
    if (!elements[id].children) {
      return [id];
    }
    return elements[id].children.reduce(function (acc, childId) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(getRemovedIds(childId)));
    }, [id]);
  };
  getUsedDataConnectorsIds(elements[rootId]);
  var removedIds = getRemovedIds(elementId);
  if ((0, _intersection2["default"])(usedDataConnectorsIds, removedIds).length > 0) {
    return false;
  }
  return true;
}
function checkForUniqueHandle(array) {
  var handles = (0, _filter2["default"])((0, _flat["default"])(array), function (value, key) {
    return /\.handle$/.test(key);
  });
  if (handles.length !== (0, _uniq2["default"])(handles).length) {
    throw new Error('The handles must be unique');
  }
  return array;
}
function checkForPawnData(object) {
  var users = [];
  (0, _forEach2["default"])(object, function (value) {
    users = [].concat(_toConsumableArray(users), _toConsumableArray(value));
  });
  var wrongUsers = users.filter(function (item) {
    return !item.pawnId || !item.pawnHash || !item.name;
  });
  if (wrongUsers.length > 0) {
    throw new Error('Element must contain pawnId, pawnHash and name');
  }
  return object;
}

// Used just to set some required arguments for functions
function required(argName) {
  throw new Error("The argument \"".concat(argName, "\" is required"));
}